import { useMediaQuery } from "@mui/material";
import { usePostHog } from "posthog-js/react";
import { useDispatch } from "react-redux";
import { openEmployerSignUp } from "../../../helpers/elp_sign_up";
import { updateViewProductEmployer } from "../../../redux/actions/dialog_action";
import {
  ButtonStyled,
  GridContainerStyled,
  GridStyled,
  ImageStyled,
  LeftContainerStyled,
  RightContainerStyled,
  TaglineContainer,
  TaglineOverline,
  TaglineSubContainer,
  TaglineSubtitle,
  TaglineTitle,
} from "./styles";

export default function EmployerKnowMore() {
  const dispatch = useDispatch();
  const belowTablet = useMediaQuery("(max-width: 767px)");
  const belowlg = useMediaQuery("(max-width: 1279px)");

  const posthog = usePostHog();
  const buttonCTA = "Post Jobs Now";
  const buttonColour = "yellow";

  function triggerEmployerSignUp() {
    openEmployerSignUp({
      posthog,
      buttonCTA: buttonCTA,
      buttonColour: buttonColour,
      section: "get_started",
    });
  }

  async function handleClickView() {
    dispatch(updateViewProductEmployer({ state: true }));
  }

  return (
    <>
      <GridStyled>
        <GridContainerStyled>
          <LeftContainerStyled>
            <ImageStyled
              src={
                "https://s3.ap-southeast-1.amazonaws.com/assets.wobbjobs.com/images/employers/employer-know-more.svg"
              }
            ></ImageStyled>

            <TaglineContainer>
              <TaglineSubContainer>
                <TaglineOverline>GET STARTED</TaglineOverline>
                <TaglineTitle>It’s easy to get started.</TaglineTitle>
              </TaglineSubContainer>
              <TaglineSubtitle>
                Signing up is free, then choose the plan that suits your hiring
                needs.
              </TaglineSubtitle>

              {belowlg && (
                <ButtonStyled
                  onClick={triggerEmployerSignUp}
                  variant="contained"
                >
                  {buttonCTA}
                </ButtonStyled>
              )}
            </TaglineContainer>
          </LeftContainerStyled>
          {!belowlg && (
            <RightContainerStyled>
              <ButtonStyled onClick={triggerEmployerSignUp} variant="contained">
                {buttonCTA}
              </ButtonStyled>
              {/* <ButtonLink onClick={handleClickView}>View our Products</ButtonLink> */}
            </RightContainerStyled>
          )}
        </GridContainerStyled>
      </GridStyled>
    </>
  );
}
